const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export const MAIN_RESEARCH_LANE = import.meta.env.VITE_MAIN_RESEARCH_LANE === 'B' ? 'B' : 'V25';
export const STAGING_LANE_B_ENABLED = import.meta.env.VITE_STAGING_LANE_B_ENABLED === 'true';
/**
 * Bahn C führt dieselbe Frage gegen das lokale Modell statt gegen Gemini.
 * Sie ist eine Variante der Bahn B und ohne deren Schalter wirkungslos.
 */
export const STAGING_LANE_C_ENABLED = import.meta.env.VITE_STAGING_LANE_C_ENABLED === 'true';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  FORGOT_PASSWORD: '/api/auth/forgot-password',
  RESET_PASSWORD: '/api/auth/reset-password',
  REFRESH: '/api/auth/refresh',
  PROFILE: '/api/auth/profile',
  USAGE: '/api/auth/usage',

  // RIS
  // The ordinary build stays on v25. Hosted test builds can explicitly select
  // pinned Lane B while retaining the same blocking JSON response contract.
  RIS_TOOLUSE: MAIN_RESEARCH_LANE === 'B' ? '/api/ris/lane-b/compat' : '/api/ris/v25/compat',
  RIS_VIEWER: '/api/ris/viewer',
  RIS_SESSIONS: '/api/ris/sessions',
  RIS_SESSION_HISTORY: '/api/ris/session',
  RIS_SESSION_RESTORE: '/api/ris/session',

  // Admin
  ADMIN_USERS: '/api/admin/users',
  ADMIN_TENANTS: '/api/admin/tenants',
  ADMIN_LOGS: '/api/admin/logs',
  ADMIN_METRICS: '/api/admin/metrics',
};

export function buildApiUrl(endpoint: string, id?: string): string {
  const fullPath = id ? `${endpoint}/${id}` : endpoint;
  return `${API_BASE_URL}${fullPath}`;
}

export default API_BASE_URL;
